import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import StaffList from "../pages/Staff/StaffList";
import CreateStaff from "../pages/Staff/CreateStaff";
import EditStaff from "../pages/Staff/EditStaff";
//@ts-ignore
import {
  PermissionRequired,
  AccessControl,
} from "@careinfo/permission-required";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<StaffList />} />
          <Route path="/staff" element={<StaffList />} />
          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateStaff />}
                allowedPermissions={["can_create_staff"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditStaff />}
                allowedPermissions={["can_update_staff"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
